// reference.ts · v1.0 · v12.10.17 (#1773) · 2026-10-16 · VoiceSpectrum AI
// v12.10.17 (#1773): the ONE display form of a call reference, shared by Messages and Contacts (moved out of MessagesPage.tsx
// unchanged, so Contacts shows #42-0700 exactly as Messages does instead of the raw #2026420700).

/**
 * v12.3.14 (#369): the canonical displayed form. Nothing is STORED with a '#' or a dash: the database holds
 * 2026420700. The '#' is display only, and it is part of what gets copied.
 */
export function formatReference(referenceNo: string | null | undefined): string {
  const digits = (referenceNo ?? '').replace(/\D/g, '');
  if (digits.length !== 10) return referenceNo ? `#${referenceNo}` : '';
  // v12.4.2: the new week-based reference is stored as ISO week-year + week + sequence ("2026360025") and a
  // human only ever sees the last six - "#36-0025". The stored year is what keeps the unique index on
  // (organization_id, reference_no) satisfied forever; it is never shown, spoken, or typed.
  // Legacy YYMMDD references (260902-0025) keep their old grouping - they cannot start "20".
  // YEAR 0..3 | WEEK 4..5 | SEQUENCE 6..9 — the engine's Grouped() uses the same offsets and a unit test
  // pins them. Getting this wrong renders "#00-25" instead of "#36-0025", which is exactly what it did first.
  if (digits.startsWith('20')) return `#${digits.slice(4, 6)}-${digits.slice(6)}`;
  return `#${digits.slice(0, 6)}-${digits.slice(6)}`;
}
